export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6900.41f49eca.jpg";